/* eslint-disable */
import React from 'react'
import cx from 'classnames'
import { Heap } from '@helpers'
import { Icon, Tooltip, Text } from '@components/UI'
import { Files } from '@constants'

const Export = ({
  type,
  url,
  name,
  className,
  config = { download: true, sketch: false },
  exportToSketch,
  visibility
}) => {
  return (
    <div className={cx('control-container dark', className)}>
      <a
        onClick={() => {
          if (visibility === 'public')
            Heap.trigger('Preview - Download - Public File')
          else Heap.trigger('Preview - Download - Private File')
        }}
        href={url}
        download={name}
        style={{
          color: 'inherit',
          lineHeight: '12px',
          height: '12px'
        }}
        rel='noopener noreferrer'
        target='_blank'
        className='item'
      >
        <Icon name='download-outline' />
      </a>
      <Tooltip
        content={
          <Text
            className='text-c semibold'
            style={{ lineHeight: 1, opacity: 0.5 }}
          >
            Download
          </Text>
        }
        group={close ? 'c7' : 'c8'}
        className='theme color-f background-a info border'
      />
      {/*
        TODO
        In order following to function we need to build
        come type of communication channel between classroom tools

        <Tooltip
          className='theme color-f background-a border export'
          content={
            <div className='tooltip-content'>
            {config.sketch &&
                [
                  ...Files.SUPPORTED_FILE_TYPES.IMAGES,
                  ...Files.SUPPORTED_FILE_TYPES.PDF
                ].includes(type) && (
                  <button className='item' onClick={exportToSketch}>
                    Open in Sketch
                  </button>
                )}
            </div>
          }
          group='c7'
        />
      */}
    </div>
  )
}

export default Export
